<template lang="pug">
  .component-force-rebook
    ModalReveal(sizing="small")
      button.button.danger(slot="trigger") Force Rebook
      .header(slot="header")
        h2 Force rebook on {{vehicle.brand}} {{vehicle.model}} {{vehicle.plate}}
        .row
          .column
            label Driver
            selectize-driver(@optionSelected="setDriver")
          .column
            label Memo
              input(type="text", v-model="body.memo")
        .row
          .columns
            label Start
              date-picker(v-model="body.start", :pickTime="true", :format="'yyyy-mm-dd hh:ii'")
          .columns
            label End
              date-picker(v-model="body.end", :pickTime="true", :format="'yyyy-mm-dd hh:ii'")
        ActionButton(:action="forceRebook") Create New Booking
</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import SelectizeDriver from '../../lists/selectize/SelectizeDriver'
  import DatePicker from '../../../DatePicker'
  import ActionButton from '../../ActionButton'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../../maggieHelper'

  export default {
    name: 'ForceRebook',
    components: {ActionButton, DatePicker, SelectizeDriver, ModalReveal},
    data() {
      return {
        body: {
          driver_id: null,
          start: null,
          end: null,
          memo: null,

        }
      }
    },
    methods: {
      setDriver(obj) {
        this.body.driver_id = obj.id
      },
      forceRebook() {
        const body = this.body
        body.start = this.$date(this.body.start).unix()
        body.end = this.$date(this.body.end).unix()
        return KeplerBackofficeSdk.vehicles.select(this.vehicle).forceRebook(body, () => {
          MaggieHelper.notification('rebook', 'Booking created')
        })
      }
    },
    props: ['vehicle']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ForceRebook.vue?22f1f1b4